import { render, staticRenderFns } from "./AllActivities.vue?vue&type=template&id=88ab7c0c&scoped=true&"
import script from "./AllActivities.vue?vue&type=script&lang=js&"
export * from "./AllActivities.vue?vue&type=script&lang=js&"
import style0 from "./AllActivities.vue?vue&type=style&index=0&id=88ab7c0c&prod&lang=scss&scoped=true&"
import style1 from "./AllActivities.vue?vue&type=style&index=1&id=88ab7c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ab7c0c",
  null
  
)

export default component.exports